//文字コードはutf-8

/**
 * floatレイアウトのリスト項目に適切なクラスを付与
 * 画像の横に来るliには is-beside-image クラスを追加
 */
export const initFloatBlockList = () => {
  const floatBlocks = document.querySelectorAll('.jsColBlock.modBlockCol--float');
  
  if (floatBlocks.length === 0) return;

  const updateListItems = () => {
    floatBlocks.forEach((block) => {
      const img = block.querySelector('.modImg');
      const listItems = block.querySelectorAll('.modListOl > li, .modListUl > li');
      
      if (!img || listItems.length === 0) return;

      // 画像の位置と高さを取得
      const imgRect = img.getBoundingClientRect();
      const imgBottom = imgRect.bottom;
      const blockRect = block.getBoundingClientRect();
      
      // 各li要素の位置を確認
      listItems.forEach((li) => {
        const liRect = li.getBoundingClientRect();
        const liTop = liRect.top;
        
        // liの上端が画像の下端より上にある場合、画像の横にある
        if (liTop < imgBottom) {
          li.classList.add('is-beside-image');
        } else {
          li.classList.remove('is-beside-image');
        }
      });
    });
  };

  // 初期化時に実行
  updateListItems();

  // 画像の読み込み完了を待つ
  const images = document.querySelectorAll('.jsColBlock.modBlockCol--float .modImg img');
  let loadedImages = 0;
  
  images.forEach((img) => {
    if (img.complete) {
      loadedImages++;
      if (loadedImages === images.length) {
        updateListItems();
      }
    } else {
      img.addEventListener('load', () => {
        loadedImages++;
        if (loadedImages === images.length) {
          updateListItems();
        }
      });
    }
  });

  // リサイズ時に再計算
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateListItems();
    }, 100);
  });
};

